import { View } from "@react-pdf/renderer";
import { useContext } from "react";
import { DefaultPage, RedBulletPointSquare, RedSlash } from "./Components";
import { perelynRed } from "./const";
import { CVContentContext, LanguageContext } from "./CVPDF";
import { ContentRow, HeaderRow, Table } from "./TableComponents";
import { LargeTextPDF, SmallTextPDF } from "./Texts";
import { cvTranslations } from "./translations";

const PROJECT_KEYS_ORDER_EN = [
  "Time period",
  "Project",
  "Goal",
  "Tasks",
  "Role",
  "Technologies",
];

const PROJECT_KEYS_ORDER_DE = [
  "Zeitraum",
  "Projekt",
  "Ziel",
  "Aufgaben",
  "Rolle",
  "Technologien",
];

export default function Projects() {
  const cvContent = useContext<any>(CVContentContext) || {};
  const language = useContext(LanguageContext);
  const t = cvTranslations[language];
  
  const PROJECT_KEYS_ORDER = language === 'de' ? PROJECT_KEYS_ORDER_DE : PROJECT_KEYS_ORDER_EN;
  
  const getKeyForLanguage = (key: string) => {
    const keyMap: { [key: string]: { en: string; de: string } } = {
      'Time period': { en: 'Time period', de: 'Zeitraum' },
      'Zeitraum': { en: 'Time period', de: 'Zeitraum' },
      'Project': { en: 'Project', de: 'Projekt' },
      'Projekt': { en: 'Project', de: 'Projekt' },
      'Goal': { en: 'Goal', de: 'Ziel' },
      'Ziel': { en: 'Goal', de: 'Ziel' },
      'Tasks': { en: 'Tasks', de: 'Aufgaben' },
      'Aufgaben': { en: 'Tasks', de: 'Aufgaben' },
      'Role': { en: 'Role', de: 'Rolle' },
      'Rolle': { en: 'Role', de: 'Rolle' },
      'Technologies': { en: 'Technologies', de: 'Technologien' },
      'Technologien': { en: 'Technologies', de: 'Technologien' },
    };
    return keyMap[key]?.['en'] || key;
  };
  return (
    <DefaultPage>
      <LargeTextPDF
        style={{
          color: perelynRed,
        }}
      >
        {t.projectExperience}
      </LargeTextPDF>
      <SmallTextPDF>{t.excerptRelevantProjects}</SmallTextPDF>
      <View
        style={{
          display: "flex",
          flexDirection: "column",
        }}
      >
        {(cvContent["projects"] || []).map((project, index) => (
          <Table
            key={index}
            style={{
              marginTop: "20px",
            }}
          >
            <HeaderRow label={project["title"] || ""} />
            {PROJECT_KEYS_ORDER.map((key, idx) => {
              const info = project.info || {};
              const englishKey = getKeyForLanguage(key);
              const value = info[englishKey] || info[key];
              if (!value) return null;

              let content;
              const isThisKeyTechnologies = key === "Technologies" || key === "Technologien";
              const isThisKeyTasks = key === "Tasks" || key === "Aufgaben";
              
              if (isThisKeyTechnologies && Array.isArray(value)) {
                content = (
                  <SmallTextPDF>
                    {value.map((tech, index) => (
                      <SmallTextPDF key={index}>
                        {tech}
                        {index < value.length - 1 && <RedSlash />}
                      </SmallTextPDF>
                    ))}
                  </SmallTextPDF>
                );
              } else if (isThisKeyTasks && Array.isArray(value)) {
                content = (
                  <View>
                    {value.map((task: any, idx: number) => (
                      <View
                        key={idx}
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          gap: "8px",
                          maxWidth: "95%",
                        }}
                      >
                        <RedBulletPointSquare
                          style={{
                            marginTop: "5px",
                          }}
                        />
                        {typeof task === "string" ? (
                          <SmallTextPDF>{task}</SmallTextPDF>
                        ) : task["description"] ? (
                          <SmallTextPDF>
                            <SmallTextPDF>{task["label"] || ""}: </SmallTextPDF>
                            {task["description"]}
                          </SmallTextPDF>
                        ) : (
                          <SmallTextPDF>{task["label"] || ""}</SmallTextPDF>
                        )}
                      </View>
                    ))}
                  </View>
                );
              } else {
                content = <SmallTextPDF>{value || ""}</SmallTextPDF>;
              }

              return (
                <ContentRow
                  key={idx}
                  label={key}
                  content={content}
                  last={idx === PROJECT_KEYS_ORDER.length - 1}
                />
              );
            })}
          </Table>
        ))}
      </View>
    </DefaultPage>
  );
}
